import React, { createContext, useContext, useState } from "react";

const LayoutContext = createContext({
  sidebarHidden: false,
  setSidebarHidden: () => {},
});

export const LayoutProvider = ({ children }) => {
  const [sidebarHidden, setSidebarHidden] = useState(false);
  return (
    <LayoutContext.Provider value={{ sidebarHidden, setSidebarHidden }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
